import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ProductionListPropertyResolveType } from './production-list-property-resolve-spec'

@Directive({
  selector: '[appItemPropertyTypeSelect]',
})
export class ProductionListPropertyResolveTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.placeholder = 'context.type'
    this.select.displayProperty = 'displayValue'
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.dataSource = enumTranslationService.enumDataSource(
      ProductionListPropertyResolveType,
      'ItemPropertyType'
    )
  }
}
